import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";
import { cargarPrestaciones } from "../../ActualizarArancel/FiltroBusqueda/actions";
const axios = require("axios");

// //////////////////
// Action Creators //
// //////////////////

export const Loading = (loading) => ({
  type: "RA/LOADING",
  loading,
});

export const LoadingFileArancelCompleto = loadingFileArancelCompleto => ({
  type: "RA/LOADINGARANCELCOMPLETO",
  loadingFileArancelCompleto
})

export const LoadingFileArancelSeleccionado = loadingFileArancelSeleccionado => ({
  type: "RA/LOADINGARANCELSELECCIONADO",
  loadingFileArancelSeleccionado
})

export const InfoExpand = (infoExpanded) => ({
  type: "RA/INFO_EXPANDED",
  infoExpanded,
});

export const CargarArancelesDetalle = (arancelesDetalle) => ({
  type: "RA/CARGA_ARANCELES_DETALLE",
  arancelesDetalle,
});

export const CargarHistorialReajustes = (historialReajustes) => ({
  type: "RA/CARGA_HISTORIAL_REAJUSTES",
  historialReajustes,
});

export const CargarPeriodoReajuste = (periodoReajuste) => ({
  type: "RA/CARGA_PERIODO_REAJUSTE",
  periodoReajuste,
});

export const CargarPeriodoReajustePQ = (periodoReajustePQ) => ({
  type: "RA/CARGA_PERIODO_REAJUSTE_PQ",
  periodoReajustePQ,
});
export const CambiarFechaVigenciaConsultaPeriodo = (valor, error) => ({
  type: "RA/CAMBIAR_FECHA_VIGENCIA_CONSULTA_PERIODO",
  valor,
  error,
});

export const SetSolicitudesEnCurso = (solicitudEnCurso) => ({
  type: "RA/SET_SOLICITUD_EN_CURSO",
  solicitudEnCurso,
});


// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const BuscarArancelesDetalle = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroMedico: globalState.filtros_CAT.centroAtencion,
    Arancel: globalState.filtros_CAT.tipoArancel,
    Codinterno: globalState.filtros_CAT.codPrestacion,
    Codfonasa: globalState.filtros_CAT.codFonasa,
    Grupo: globalState.filtros_CAT.tipoPrestacion,
    pageNumber: 1,
    pageSize: 10,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  //console.log("PARAMETROS BUSCAR ARANCEL DETALLE: ");
  //console.log(params);

  axios({
    method: "post",
    url: `${apiConfig.apiUri}/v1/prestaciones/prestador2/`,
    // headers: {
    //   "Content-Type": "text/plain",
    //   // Authorization: localStorage.getItem("id_token"),
    //   "Access-Control-Allow-Origin": "*",
    //   "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, PATCH, OPTIONS",
    // },
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
  }).then((response) => {
    /*console.log("RESPONSE DESDE AXIOS API PRESTADOR2 FILTRO BUSQUEDA");
    console.log(response.data);
    console.log(response.status);
    console.log(response.statusText);
    console.log(response.headers);
    console.log(response.config);*/

    if (response.status === 200) {
      //console.log("RESPONSE OK");
      //console.log(response.data);

      if (Array.isArray(response.data)) {
        //trace.information("BuscarArancelesDetalle", response.data);
        dispatch(CargarArancelesDetalle(response.data));
      } else {
        throw response.data;
      }
    }
  }).catch((error) => {
    if (error.response) {
      console.log("MENSAJE DE Error 4xx");
      console.log(error);
    } else {
      console.log("MENSAJE DE Error 5xx");
      console.log(error);
    }
    trace.error("BuscarPrestaciones", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });

  // fetch(`${apiConfig.apiUri}/v1/prestaciones/prestador2/`, {
  //   method: "POST",
  //   headers: {
  //     // "Content-Type": "application/json",
  //     // Authorization: localStorage.getItem('id_token'),
  //   },
  //   credentials: "same-origin",
  //   body: JSON.stringify(params),
  //   timeout: 9000,
  // })
  //   .then((response) => {
  //     if (!response.ok) { throw response; }
  //     return response.json();
  //   })
  //   .then((json) => {
  //     if (Array.isArray(json)) {
  //       trace.information("BuscarArancelesDetalle", json);
  //       dispatch(CargarArancelesDetalle(json));
  //       dispatch(Loading(false));
  //       dispatch(InfoExpand(false));
  //     } else {
  //       throw json;
  //     }
  //   })
  //   .catch((error) => {
  //     trace.error("BuscarArancelesDetalle", error);
  //     dispatch(ErrorSnacktOpen(
  //       "Error al buscar detalle de aranceles:",
  //       error,
  //     ));
  //   });
};

export const BuscarHistorialReajustes = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    RutPrestador: globalState.rutPrestador,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/reajustes/getHistorial/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("BuscarHistorialReajustes", json);
        dispatch(CargarHistorialReajustes(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("BuscarHistorialReajustes", error);
      dispatch(ErrorSnacktOpen(
        "Error al buscar el historial de reajustes:",
        error,
      ));
    });
};

export const ValidarPeriodoReajuste = (fechaVigencia) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    RutPrestador: globalState.rutPrestador,
    Isapre: globalState.isapre,
    FechaVigencia: fechaVigencia,
    ValidoArancel: 1,
    ValidoPaquetes: 0,
    token: globalState.token,
  };
  //console.log("ValidarPeriodoReajuste");
  //console.log(params);
  fetch(`${apiConfig.apiUri}/v1/reajustes/consultarPeriodoReajuste/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //console.log(json);
      if (json) {
        //trace.information("ValidarPeriodoReajuste", json);
        dispatch(CargarPeriodoReajuste(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ValidarPeriodoReajusteArancel", error);
      dispatch(ErrorSnacktOpen(
        "Error al validar periodo de reajuste de Arancel:",
        error,
      ));
    });
};

export const ValidarPeriodoReajustePaquetes = (fechaVigencia) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    RutPrestador: globalState.rutPrestador,
    Isapre: globalState.isapre,
    FechaVigencia: fechaVigencia,
    ValidoArancel: 0,
    ValidoPaquetes: 1,
    token: globalState.token,
  };
  //console.log("ValidarPeriodoReajuste");
  //console.log(params);
  fetch(`${apiConfig.apiUri}/v1/reajustes/consultarPeriodoReajuste/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //console.log(json);
      if (json) {
        //trace.information("ValidarPeriodoReajuste", json);
        dispatch(CargarPeriodoReajustePQ(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ValidarPeriodoReajustePQ", error);
      dispatch(ErrorSnacktOpen(
        "Error al validar periodo de reajuste de Paquetes:",
        error,
      ));
    });
};


// WEBPACK FOOTER //
// ./src/components/ReajustarArancel/FiltroBusqueda/actions.js